import { render } from "./patrolS.vue?vue&type=template&id=7918f228&scoped=true"
import script from "./patrolS.vue?vue&type=script&lang=js"
export * from "./patrolS.vue?vue&type=script&lang=js"

import "./patrolS.vue?vue&type=style&index=0&id=7918f228&scoped=true&lang=less"

import exportComponent from "G:\\B030transformer\\demo (2)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7918f228"]])

export default __exports__